import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Dialog from "../dialogBox/dialogBox"; 
import "./footer.css";

export default function Footer() {
  const [isAboutUsOpen, setIsAboutUsOpen] = useState(false);
  const [isContactUsOpen, setIsContactUsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const openAboutUsDialog = () => {
    setIsAboutUsOpen(true);
  };

  const closeAboutUsDialog = () => {
    setIsAboutUsOpen(false);
  };

  const openContactUsDialog = () => {
    setIsContactUsOpen(true); // Open the Contact Us dialog
  };

  const closeContactUsDialog = () => {
    setIsContactUsOpen(false); // Close the Contact Us dialog
  };


  return (
    <div className="footer">
      <div className="footer-content">
        <a href="https://www.facebook.com/forloveofwriters/" target="_blank">
          <i className="sidebarIcon-home fab fa-facebook-square"></i>
        </a>
        <span className="pipe">&#124;</span>

        <a href="https://www.instagram.com/4loveofwriters/" target="_blank">
          <i className="sidebarIcon-home fab fa-instagram-square"></i>
        </a>
        <span className="pipe">&#124;</span>

        <a href="https://www.linkedin.com/company/forloveofwriters/" target="_blank">
          <i className="sidebarIcon-home fab fa-linkedin-square"></i>
        </a>
      </div>

      <div className="centerItems">
        <Link to="#" onClick={openAboutUsDialog}>
          ABOUT US
        </Link>
        <Link to="/partnerships">PARTNERSHIPS</Link>
        {/* <Link to="/generalDisclaimer">General Disclaimer</Link>
        <Link to="/codeofConduct">Code of Conduct</Link>
        <Link to="/cookiePolicy">Cookie Policy</Link> */}
        <Link to="#" onClick={openContactUsDialog}>
          CONTACT US
        </Link>
        <Link to="/privacyPolicy">PRIVACY POLICY</Link>
        <Link to="/tos">TERMS OF SERVICE</Link>
       
      </div>

      <div className="copyright">
        <p style={{paddingBottom:"10px"}}>&copy; 2024, For Love of Writers</p>
      </div>

      {/* About Us Dialog */}
      <Dialog
        isOpen={isAboutUsOpen}
        onClose={closeAboutUsDialog}
        title="About Us"
      >
        <p>
          For Love of Writers is a dedicated community for writers who are serious about their craft and committed to sharing their voice. We believe writing should be as diverse and authentic as the people behind the words, and that every writer deserves to be heard.
        </p>
        <br></br>
        <p>
          Instead of trying to build an audience alone, members of For Love of Writers connect with a supportive network of peers and readers who value meaningful storytelling. Here, writers don’t just write in isolation; they grow, share, and find real connections with those who want to read and respond.
        </p>
        <br></br>
        <p>
          Whether you're just starting out or already publishing, this is a space to write with purpose, connect with your audience, and be part of something bigger than the blank page.
        </p>
      </Dialog>

      <Dialog
        isOpen={isContactUsOpen}
        onClose={closeContactUsDialog}
        title="Contact Us"
      >
        <p>Questions or compliments? We’d love to hear from you!
          <br></br>
          <br></br>Contact us at:
          <br></br>support@forloveofwriters.com</p>
        
      </Dialog>

      </div>
  );
}
